import { EVENTS_LOAD_MORE_WRAP_SELECTOR } from '../../utils/events-calendar-load-more';
import type { NewsFiltersOptions } from '../../utils/news-filters';

export const EVENTS_CALENDAR_AJAX_CONFIG = {
  gridSelector: '[data-events-grid]',
  wrapSelector: EVENTS_LOAD_MORE_WRAP_SELECTOR,
  cardSelector: 'a.events-calendar-item',
  loadingSelector: '.events-calendar-content',
  skeletonVariant: 'events' as const,
  skeletonCount: 3,
  search: {
    inputId: 'news-search',
    highlight: {
      cardSelector: 'a.events-calendar-item',
      fields: [{ selector: '.event-card-title' }, { selector: '.event-card-description' }],
    },
  },
};

export const EVENTS_CALENDAR_FILTER_SUBMIT_OPTIONS: NewsFiltersOptions = {
  includeActivityFilters: true,
  preserveView: true,
  ajax: EVENTS_CALENDAR_AJAX_CONFIG,
};
